const initialState = {
  user: {},
  flash: {},
  activity: {},
};

export default initialState;